import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { nameMaxLength } from '../../Constant.js'
import axios from 'axios'
import CheckPermission from '../../common/Permissions/CheckPermission.js'

class EventCompanyAdd extends React.Component {
  state = {
    is_active: 'true',
    company_name_en: '',
    company_name_ar: '',
    company_short_name_en: '',
    company_short_name_ar: '',
    company_img_url: '',
    banner_img_url: '',
    company_img_url_ar: '',
    banner_img_url_ar: '',
    company_description_en: '',
    company_description_ar: '',
    category_id: '',
    commission: '',
    Category_data: [],
    user_id: '',
    isSaving: false,
    isData: false,
    Edit: false,
    bannerEdit: false,
    companyEditAr: false,
    bannerEditAr: false,

    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',

    b2c_commission_type: '',
    b2b_commission_type: '',
    b2b_commission: '',
    b2c_commission: '',
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    if (e.target.name == 'company_img_url') {
      this.setState({ Edit: false })
      this.setState({ img: URL.createObjectURL(e.target.files[0]) })
    } else if (e.target.name == 'banner_img_url') {
      this.setState({ bannerEdit: false })
      this.setState({ banner_img: URL.createObjectURL(e.target.files[0]) })
    } else if (e.target.name == 'company_img_url_ar') {
      this.setState({ companyEditAr: false })
      this.setState({ img_ar: URL.createObjectURL(e.target.files[0]) })
    } else if (e.target.name == 'banner_img_url_ar') {
      this.setState({ bannerEditAr: false })
      this.setState({ banner_img_ar: URL.createObjectURL(e.target.files[0]) })
    }
  }
  onSaveDataBoat = () => {
    var that = this
    // if (
    //   that.state.commission === undefined ||
    //   that.state.commission === null ||
    //   that.state.commission === '' ||
    //   that.state.commission >= 100
    // ) {
    //   document.getElementById('commission')?.focus()
    //   that.setState({ isData: false })
    //   Swal.fire({
    //     title: 'Commission must be 1 to 100',
    //     icon: 'error',
    //     text: '',
    //     type: 'error',
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Ok',
    //   })
    //   return false
    // }

    if (this.state.b2b_commission_type && (!this.state.b2b_commission || this.state.b2b_commission == 0)) {
      document.getElementById('b2b_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2B commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    if (this.state.b2c_commission_type && (!this.state.b2c_commission || this.state.b2c_commission == 0)) {
      document.getElementById('b2c_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2C commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    const formData = new FormData()
    formData.append('company_name_en', this.state.company_name_en)
    formData.append('user_id', this.state.user_id === 'no_owner' ? '' : this.state.user_id?.toString())
    formData.append('company_name_ar', this.state.company_name_ar)
    formData.append('company_short_name_en', this.state.company_short_name_en)
    formData.append('company_short_name_ar', this.state.company_short_name_ar)
    formData.append('company_description_en', this.state.company_description_en)
    formData.append('company_description_ar', this.state.company_description_ar)

    formData.append('meta_title_en', this.state.meta_title_en)
    formData.append('meta_title_ar', this.state.meta_title_ar)
    formData.append('meta_desc_en', this.state.meta_desc_en)
    formData.append('meta_desc_ar', this.state.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.meta_keywords_ar)

    formData.append('commission', this.state.commission)
    formData.append('is_active', this.state.is_active)

    formData.append('b2b_commission_type', this.state.b2b_commission_type || '')
    formData.append('b2b_commission', this.state.b2b_commission || '')
    formData.append('b2c_commission_type', this.state.b2c_commission_type || '')
    formData.append('b2c_commission', this.state.b2c_commission || '')

    if (this.props.company_id) {
      that.setState({ isData: true })
      formData.append('id', this.props.company_id)

      if (this.state.company_img_url?.name) {
        formData.append('company_img_url', this.state.company_img_url)
      }
      if (this.state.banner_img_url?.name) {
        formData.append('banner_img_url', this.state.banner_img_url)
      }
      if (this.state.company_img_url_ar?.name) {
        formData.append('company_img_url_ar', this.state.company_img_url_ar)
      }
      if (this.state.banner_img_url_ar?.name) {
        formData.append('banner_img_url_ar', this.state.banner_img_url_ar)
      }
      axios
        .put(Constant.getAPI() + '/event-companies/edit-event-company', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Event Company has been Updated`, 'success')
            window.location.href = `#/event-companies`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      that.setState({ isData: true })
      if (this.state.company_img_url) {
        formData.append('company_img_url', this.state.company_img_url)
      }
      if (this.state.banner_img_url) {
        formData.append('banner_img_url', this.state.banner_img_url)
      }
      if (this.state.company_img_url_ar) {
        formData.append('company_img_url_ar', this.state.company_img_url_ar)
      }
      if (this.state.banner_img_url_ar) {
        formData.append('banner_img_url_ar', this.state.banner_img_url_ar)
      }
      axios
        .post(Constant.getAPI() + '/event-companies/add-event-company', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Event Company has been Added`, 'success')
            window.location.href = `#/event-companies`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }
  getEventCompanyList = async () => {
    await axios
      .get(Constant.getAPI() + `/event-companies/list-event-companies/ALL`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          const matchItem = res?.data?.data?.filter((itm) => itm?.id === this?.props?.company_id)

          if (matchItem?.length) {
            const itm = matchItem[0]

            this.setState({
              ...itm,
            })
            this.setState({
              Edit: true,
              bannerEdit: true,
              bannerEditAr: true,
              companyEditAr: true,
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  componentDidMount() {
    this.getEventCompanyList()
    this.getVendorLists()
  }
  getVendorLists = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + '/admin/list-users/event-vendor', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          that.setState({
            Vendors_List: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="company_name_en"
                    id="company_name_en"
                    placeholder=" Company Name: English"
                    onChange={this.handleChange}
                    value={this.state.company_name_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.company_name_en
                    ? this.state.company_name_en.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="company_name_ar"
                    id="company_name_ar"
                    placeholder="Company Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.company_name_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.company_name_ar
                    ? this.state.company_name_ar.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Short Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="company_short_name_en"
                    id="company_short_name_en"
                    placeholder="Company Short Name: English"
                    onChange={this.handleChange}
                    value={this.state.company_short_name_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.company_short_name_en
                    ? this.state.company_short_name_en.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Short Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="company_short_name_ar"
                    id="company_short_name_ar"
                    placeholder="Company Short Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.company_short_name_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.company_short_name_ar
                    ? this.state.company_short_name_ar.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Description: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="company_description_en"
                    id="company_description_en"
                    placeholder="Company Description: English"
                    onChange={this.handleChange}
                    value={this.state.company_description_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Description: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="company_description_ar"
                    id="company_description_ar"
                    placeholder="Company Description: Arabic"
                    onChange={this.handleChange}
                    value={this.state.company_description_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Owner</label>
                <div className="col-sm-9">
                  <select
                    name="user_id"
                    className="form-control"
                    value={this.state.user_id}
                    onChange={this.handleChange}
                  >
                    <option value="no_owner">No Owner</option>
                    {this.state.Vendors_List !== undefined &&
                    this.state.Vendors_List !== null &&
                    this.state.Vendors_List !== [] &&
                    this.state.Vendors_List.length > 0
                      ? this.state.Vendors_List?.map((Vendors_List) => (
                          <option
                            value={Vendors_List?.id}
                            key={Vendors_List?.id}
                          >
                            {Vendors_List?.first_name}
                            {Vendors_List?.last_name}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="commission"
                    id="commission"
                    placeholder="In percentage 1 to 100"
                    value={this.state.commission}
                  />
                </div>
              </div>
            </div> */}
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Commission</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2B Commission Type</label>
                <div className="col-sm-9">
                  <select
                    name="b2b_commission_type"
                    className="form-control"
                    value={this.state.b2b_commission_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2B Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="b2b_commission"
                    id="b2b_commission"
                    // placeholder="In percentage 1 to 100"
                    value={this.state.b2b_commission}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2C Commission Type</label>
                <div className="col-sm-9">
                  <select
                    name="b2c_commission_type"
                    className="form-control"
                    value={this.state.b2c_commission_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2C Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="b2c_commission"
                    id="b2c_commission"
                    // placeholder="In percentage 1 to 100"
                    value={this.state.b2c_commission}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option
                      value="true"
                      name=""
                    >
                      Active
                    </option>
                    <option
                      value="false"
                      name=""
                    >
                      Inactive
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="company_img_url"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                    <div style={{ color: 'red' }}>Image height width must be 1:1 Ratio or 900 x 900</div>
                    <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                  </div>
                  {this.state.Edit ? (
                    <img
                      height="200px"
                      src={Constant.getImage() + this.state.company_img_url}
                      alt="img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : (
                    <img
                      height="200px"
                      src={this.state.img || './assets/images/no_image.png'}
                      alt="img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Banner Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="banner-img"
                        name="banner_img_url"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                    <div style={{ color: 'red' }}>Image height width must be 5:2 Ratio or 1160 x 600</div>
                    <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                  </div>
                  {this.state.bannerEdit ? (
                    <img
                      height="200px"
                      src={Constant.getImage() + this.state.banner_img}
                      alt="banner img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : (
                    <img
                      height="200px"
                      src={this.state.banner_img || './assets/images/no_image.png'}
                      alt="banner img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: Arabic</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img_ar"
                        name="company_img_url_ar"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                    <div style={{ color: 'red' }}>Image height width must be 1:1 Ratio or 900 x 900</div>
                    <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                  </div>
                  {this.state.companyEditAr ? (
                    <img
                      height="200px"
                      src={Constant.getImage() + this.state.company_img_url_ar}
                      alt="img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : (
                    <img
                      height="200px"
                      src={this.state.img_ar || './assets/images/no_image.png'}
                      alt="img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Banner Image: Arabic</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="banner-img-ar"
                        name="banner_img_url_ar"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                    <div style={{ color: 'red' }}>Image height width must be 5:2 Ratio or 1160 x 600</div>
                    <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                  </div>
                  {this.state.bannerEditAr ? (
                    <img
                      height="200px"
                      src={Constant.getImage() + this.state.banner_img_ar}
                      alt="banner img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : (
                    <img
                      height="200px"
                      src={this.state.banner_img_ar || './assets/images/no_image.png'}
                      alt="banner img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <CheckPermission permission={'manage-meta-tags'}>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              ></div>
              <h5 style={{ marginBottom: 23, marginLeft: 13, fontWeight: 'bold', fontSize: 18 }}>Meta Settings</h5>
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_en"
                      id="meta_title_en"
                      placeholder="Meta Title: English"
                      onChange={this.handleChange}
                      value={this.state.meta_title_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_ar"
                      id="meta_title_ar"
                      placeholder="Meta Title: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_title_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta keywords: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_en"
                      id="meta_keywords_en"
                      placeholder="Meta keywords: English"
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta keywords: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_ar"
                      id="meta_keywords_ar"
                      placeholder="Meta keywords: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_en"
                      id="meta_desc_en"
                      placeholder="Meta Description: English"
                      onChange={this.handleChange}
                      value={this.state.meta_desc_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_ar"
                      id="meta_desc_ar"
                      placeholder="Meta Description: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_desc_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_en"
                      id="h1_en"
                      placeholder="H1: English"
                      onChange={this.handleChange}
                      value={this.state.h1_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_ar"
                      id="h1_ar"
                      placeholder="H1: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h1_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_en"
                      id="h2_en"
                      placeholder="H2: English"
                      onChange={this.handleChange}
                      value={this.state.h2_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_ar"
                      id="h2_ar"
                      placeholder="H2: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h2_ar}
                    />
                  </div>
                </div>
              </div>
            </CheckPermission>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveDataBoat}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            {/* <button onClick={this.onSaveDataBoat} className="btn btn-grd-disabled mr-2"><i className="icofont icofont-save"></i> Save</button> */}

            <Link
              to={`/event-companies`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default EventCompanyAdd
